import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Routes } from '@angular/router';
import { MaterialModule } from '../../../assets/material/material.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../../guards/auth.guard';
import { SamlGuard } from '../../guards/saml.guard';
import { PaperlessEnrollmentComponent } from './containers/paperless-enrollment/paperless-enrollment.component';
import { SimplifiedFooterComponent } from '../../containers/simplified-footer/simplified-footer.component';
import { HeaderNavComponent } from '../../containers/header-nav/header-nav.component';
import { HeaderNavSkeletonComponent } from '../../containers/header-nav-skeleton/header-nav-skeleton.component';
import { ApiBtnComponent } from '../shared/components/api-btn/api-btn.component';
import { IconCloseComponent } from '../shared/components/icon-close/icon-close.component';
import { EggSpinnerOverlayComponent } from '../shared/components/egg-spinner-overlay/egg-spinner-overlay.component';
import { UpdateEmailModalComponent } from './containers/update-email-modal/update-email-modal.component';
import { OptInNgrxModule } from '../opt-in/opt-in.module';
import { HubCardVerificationModalComponent } from '../shared/components/hub-card-verification-modal/hub-card-verification-modal.component';
import { LoanRedirectComponent } from './containers/loan-redirect/loan-redirect.component';
import { RedirectComponent } from './containers/redirect/redirect.component';
import { Saml2Component } from './containers/saml2/saml2.component';
import { NotificationComponent } from '../shared/components/notification/notification.component';
import { IconCircleCheckComponent } from '../shared/components/icon-circle-check/icon-circle-check.component';

export const redirectRoutes: Routes = [
  { path: 'products', component: RedirectComponent, canActivate: [AuthGuard] },
  { path: 'paperless-enrollment', component: PaperlessEnrollmentComponent, canActivate: [AuthGuard] },
  { path: 'saml2', component: Saml2Component, canActivate: [AuthGuard, SamlGuard] },
  { path: 'loan', component: LoanRedirectComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/redirect/products', pathMatch: 'full' },
  { path: '*p*', redirectTo: '/redirect/products', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    RedirectComponent,
    Saml2Component,
    LoanRedirectComponent,
    PaperlessEnrollmentComponent,
    UpdateEmailModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    OptInNgrxModule,
    SimplifiedFooterComponent,
    HeaderNavComponent,
    IconCloseComponent,
    HeaderNavSkeletonComponent,
    ApiBtnComponent,
    EggSpinnerOverlayComponent,
    NotificationComponent,
    HubCardVerificationModalComponent,
    IconCircleCheckComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class RedirectModule {}
